export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2PQMjD9DwACpgGPECLj8gAAAABJRU5ErkJggg=="